import * as _ from 'lodash'

export function getGeocoderResult(results: google.maps.GeocoderResult[]) {
  const filteredResult = results.filter(result => !contains(result, ['plus_code']))
  if (filteredResult.length == 0) return null
  const result = filteredResult[0]
  const { countryCode, city } = countryAndCity(filteredResult)
  const zipcode = getComponent(result, ['postal_code'])
  return {
    countryCode,
    city,
    zipcode,
    address: result.formatted_address
  }
}

function contains(item: google.maps.GeocoderResult, componentTypes: string[]): boolean {
  return _.flatten(item
    .address_components
    .map(component => component.types))
    .some(value => componentTypes.includes(value))
}

function typesContains(item: string[], componentTypes: string[]): boolean {
  return item.some(value => componentTypes.includes(value))
}

function getComponent(item: google.maps.GeocoderResult, componentTypes: string[], longName: boolean = true): string {
  const component = item.address_components.filter(component => {
    const includes = componentTypes.map(type => component.types.includes(type)).filter(value => value === true)
    return includes.length > 0
  })    
  if (component.length == 0) return null
  if (longName) return component[0].long_name
  return component[0].short_name
}

function countryAndCity(results: google.maps.GeocoderResult[]) {
  const cityFilter = ['administrative_area_level_1', 'locality', 'administrative_level_1']
  const politicalResult = results.find(result => typesContains(result.types, cityFilter))
  const countryCode = getComponent(politicalResult, ['country'], false)
  const city = getComponent(politicalResult, cityFilter)
  return {
    countryCode,
    city
  }
}